var cnt_click = 0;

var pInfScrLoading = false;
var pInfScrDelay = 100;
function pInfScrExecute() {
  var gridscrollt = jQuery('.product_grid_wrapper').height() + jQuery('.product_grid_wrapper').offset().top;
  var gridscroll = gridscrollt - (jQuery(window).height() * 2);
  if(jQuery(window).scrollTop() > gridscroll){
    var loadingImage;
    pInfScrNode = jQuery('.more').last();	
    pInfScrURL = jQuery('.more a').last().attr("href");
    if(!pInfScrLoading && pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
      jQuery.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          loadingImage = pInfScrNode.clone().empty().append('<img src="https://cdn.shopify.com/s/files/1/0578/0832/2735/files/1488.gif?v=1695884215" />');
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();
        },
        success: function(data) {
          loadingImage.remove();
          var filteredData = jQuery(data).find(".product_grid_wrapper").html();
          jQuery('.product_grid_wrapper').append(filteredData);					
          pInfScrLoading = false;
          if(typeof theme.LazyImage.load == 'function'){
            theme.LazyImage.load(); 
          }
        },
        dataType: "html"
      });
    }
    
  }
}

jQuery(document).ready(function(){
  jQuery('body').on('click','a[data-ajax_url="fetch_collection"]',function(e){
    e.preventDefault();
    cnt_click++;
    var collection_link = jQuery(this).attr('href') + '?view=filter_type';
    // console.log(collection_link);
    jQuery.get(collection_link,function (data){
      jQuery('.append_collection_page').html(data);
      if(typeof theme.LazyImage.load == 'function'){
        theme.LazyImage.load(); 
      }
      if(cnt_click != 1){
        jQuery('html, body').animate({
          scrollTop: jQuery(".main_page_wrpr").offset().top - 40
        }, 500); 
      }
    });
  });

  jQuery('body').on('change','select[name="select_categories"], select[name="select_type"]',function(e){
    cnt_click++;
    var collection_link = '/collections/' + jQuery(this).val() + '?view=filter_type';
    // console.log(collection_link);
    jQuery.get(collection_link,function (data){
      jQuery('.append_collection_page').html(data);
      if(typeof theme.LazyImage.load == 'function'){
        theme.LazyImage.load(); 
      }
      if(cnt_click != 1){
        jQuery('html, body').animate({
          scrollTop: jQuery(".main_page_wrpr").offset().top - 40
        }, 500); 
      }
    });
  });
  jQuery('a[data-ajax_url="fetch_collection"]').first().trigger('click');
  
  jQuery(window).scroll(function(){
    if(jQuery('.product_grid_wrapper').length > 0){
      setTimeout(function(){
        pInfScrExecute();
      },pInfScrDelay); 
    }
  });
  
});
